module.exports = __webpack_public_path__ + "static/accessingData-1a47f2da9414ed17f76e2eb42d4f841b.gif";